module.exports = __webpack_public_path__ + "static/media/4.c4b44681.png";